import api from "../api/api";

// GET semua partner types
export const getAllPartnerTypes = async () => {
  const res = await api.get("/partner-types");
  return res.data.data; // atau sesuaikan jika struktur respons beda
};

// CREATE partner type baru
export const createPartnerType = async (payload) => {
  const res = await api.post("/partner-types", payload);
  return res.data;
};

// UPDATE partner type berdasarkan ID
export const updatePartnerType = async (id, payload) => {
  const res = await api.put(`/partner-types/${id}`, payload);
  return res.data;
};

// DELETE partner type berdasarkan ID
export const deletePartnerType = async (id) => {
  const res = await api.delete(`/partner-types/${id}`);
  return res.data;
};
